function dateKey(value) {
  if (value && typeof value.format === "function") return value.format("YYYY-MM-DD")
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value.toISOString().slice(0, 10) : ""
  return typeof value === "string" ? value.slice(0, 10) : ""
}

function isValidDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const date = new Date(`${value}T00:00:00.000Z`)
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
}

export function normalizeSchoolDayExceptions(values, month) {
  const dates = (Array.isArray(values) ? values : []).filter(
    (value) => typeof value === "string" && isValidDate(value) && (!month || value.slice(0, 7) === month),
  )
  return [...new Set(dates)].sort()
}

export function collectSchoolDayExceptions(monthlyOverrides = {}, month, currentDates = []) {
  const dates = []
  for (const [key, settings] of Object.entries(monthlyOverrides || {})) {
    if (key !== month && /^\d{4}-\d{2}$/.test(key)) dates.push(...normalizeSchoolDayExceptions(settings?.schoolDayExceptions, key))
  }
  dates.push(...normalizeSchoolDayExceptions(currentDates, month))
  return [...new Set(dates)].sort()
}

export function isPlanningSchoolDay(employee, value, schoolHolidays = []) {
  const key = dateKey(value)
  if (!employee?.isApprentice || !isValidDate(key)) return false
  if ((employee.schoolDayExceptions || []).includes(key)) return false
  const weekday = new Date(`${key}T00:00:00.000Z`).getUTCDay() || 7
  if (!(employee.schoolDays || []).some((day) => Number(day?.dayOfWeek ?? day) === weekday)) return false
  return !(schoolHolidays || []).some((holiday) => {
    const start = dateKey(holiday?.startDate || holiday?.start)
    const end = dateKey(holiday?.endDate || holiday?.end)
    return isValidDate(start) && isValidDate(end) && key >= start && key <= end
  })
}
